enum MouseMode {
	NONE = "NONE",
	MOVE = "MOVE",
	TEXT = "TEXT",
	SELECT = "SELECT",
	ZOOM = "ZOOM",
	POINT = "POINT",
	RECTANGLE = "RECTANGLE",
	FORM = "FORM"
}

export default MouseMode;